import { observer } from 'mobx-react';
import { ActionIcon, Flex, Table, TextInput } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import React, { Dispatch, SetStateAction } from 'react';
import { t } from 'i18next';
import { IQuestionScore } from '../../../global/entities/Questionnaires/Questionnaires.ts';

export interface ISurveyCategoriesProps {
    question: any;
    onChangesScores: Dispatch<SetStateAction<IQuestionScore[]>>;
    showErrors: boolean;
    index: any;
}

export const scoringRegex = /^ *(-?\d+:-?\d+)( *, *-?\d+:-?\d+)* *$/;

const SurveyCategoriesRow: React.FC<ISurveyCategoriesProps> = observer(
    ({ question, onChangesScores, showErrors, index }) => {
        const onClickDelete = (id: number) => {
            onChangesScores((prev) => prev.filter((q) => q.id !== id));
        };

        const updateQuestionField = (field: keyof IQuestionScore, value: any) => {
            onChangesScores((prev) => {
                const updated = [...prev];
                const currentQuestion = updated[index];

                const updatedQuestion = {
                    ...currentQuestion,
                    [field]: value,
                };

                updated[index] = updatedQuestion;
                return updated;
            });
        };

        return (
            <Table.Tr
                key={index}
                style={{
                    background: index % 2 === 1 ? undefined : 'var(--Background-Gray-light, #E9ECEF)',
                    pointer: 'cursor',
                }}
            >
                <Table.Td>
                    <TextInput
                        value={question.questionName}
                        onChange={(e) => updateQuestionField('questionName', e.currentTarget.value)}
                        size="xs"
                        error={showErrors && !question.questionName ? t('formError.required') : undefined}
                    />
                </Table.Td>
                <Table.Td>
                    <TextInput
                        value={question.categoryFr}
                        onChange={(e) => updateQuestionField('categoryFr', e.currentTarget.value)}
                        size="xs"
                        error={showErrors && !question.categoryFr ? t('formError.required') : undefined}
                    />
                </Table.Td>
                <Table.Td>
                    <TextInput
                        value={question.categoryEn}
                        onChange={(e) => updateQuestionField('categoryEn', e.currentTarget.value)}
                        size="xs"
                        error={showErrors && !question.categoryEn ? t('formError.required') : undefined}
                    />
                </Table.Td>
                <Table.Td>
                    <TextInput
                        maxLength={999999}
                        value={question.scoring}
                        onChange={(event) => updateQuestionField('scoring', event.currentTarget.value)}
                        size="xs"
                        error={
                            showErrors && !scoringRegex.test(question.scoring)
                                ? t('formError.questionnaireScoring')
                                : undefined
                        }
                    />
                </Table.Td>
                <Table.Td>
                    <Flex align={'center'}>
                        <ActionIcon
                            tabIndex={-1}
                            variant="subtle"
                            color="gray"
                            onClick={() => onClickDelete(question.id)}
                        >
                            <IconTrash size={18} />
                        </ActionIcon>
                    </Flex>
                </Table.Td>
            </Table.Tr>
        );
    },
);

export default SurveyCategoriesRow;
